"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseManifest = exports.parseWebpackManifest = exports.parseRegistryManifest = void 0;
var RegistryError_1 = require("../errors/RegistryError");
var parseWebpackManifest_1 = require("./parseWebpackManifest");
Object.defineProperty(exports, "parseWebpackManifest", { enumerable: true, get: function () { return parseWebpackManifest_1.parseWebpackManifest; } });
var parseRegistryManifest_1 = require("./parseRegistryManifest");
Object.defineProperty(exports, "parseRegistryManifest", { enumerable: true, get: function () { return parseRegistryManifest_1.parseRegistryManifest; } });
var isRegistryManifest = function (library) {
    return (library.hasOwnProperty('topology') &&
        library.hasOwnProperty('manifest') &&
        library.manifest.hasOwnProperty('version'));
};
var isWebpackManifest = function (library) {
    return (library.hasOwnProperty('topology') && library.hasOwnProperty('manifest'));
};
function parseManifest(library, libraryAssetsPatterns) {
    if (libraryAssetsPatterns === void 0) { libraryAssetsPatterns = []; }
    if (isRegistryManifest(library)) {
        return parseRegistryManifest_1.parseRegistryManifest(library);
    }
    else if (isWebpackManifest(library)) {
        return parseWebpackManifest_1.parseWebpackManifest(library, libraryAssetsPatterns);
    }
    else {
        throw RegistryError_1.createInternalException();
    }
}
exports.parseManifest = parseManifest;
//# sourceMappingURL=parseManifest.js.map